<template>
  <div>
    <Header />
    <div class="c-financial-content">
      <div class="c-financial-list-bx">
        <h2>发布项目需求</h2>
        <ul class="c-financial-list">
          <li>
            <p class="c-financial-lf-txt"><span class="needed">*</span>发布类型： </p>
            <div class="c-financial-rt-input">
              <a @click="() => changeType(type.key)" v-for="type in publishTypes" :key="type.key" href="javascript:;"
                class="project" :class="{active: type.active}">{{type.name}}</a>
            </div>
          </li>
          <template v-if="selectedTypeKey === 0">

            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>服务类型：</p>
              <div class="c-financial-rt-input">
                <select class="select-box" v-model="projectcategory">
                  <option value="咨询规划">咨询规划</option>
                  <option value="专业设计">专业设计</option>
                  <option value="工程建设">工程建设</option>
                  <option value="人力外包">人力外包</option>
                  <option value="监理审计">监理审计</option>
                  <option value="创新场景">创新场景</option>
                  <option value="金融服务">金融服务</option>
                </select>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>专业领域：</p>
              <div class="c-financial-rt-input">
                <select class="select-box" v-model="selzy">
                  <option v-for="key,index in zyly" :value="index">{{key}}</option>
                </select>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>细分领域：</p>
              <div class="c-financial-rt-input">
                <select class="select-box" v-model="selxf">
                  <option v-for="key,index in xfly[selzy]" :value="index">{{key}}</option>
                </select>
              </div>
            </li>
            <!-- <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>专业领域：</p>
              <div class="c-profile-rt-input">
                <NewConstructor :selectedOptions="industryCategory" v-on:dataChange="handleNewConstructorChange" />
              </div>
            </li> -->
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>所在地区：</p>
              <div style="display: inline-block;float:left;margin-right:20px;">
                <CityCascader placeholderstr="选择省市" v-on:resetDefaultValue="setAddress" :defaultlevel1name="province"
                  :defaultlevel2name="district"></CityCascader>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目名称：</p>
              <div class="c-financial-rt-input">
                <input type="text" maxlength="18" placeholder="项目名称" v-model="title">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目描述：</p>
              <div class="c-financial-rt-input">
                <textarea class="textarea" placeholder="请描述你的需求" v-model="projectdetail"></textarea>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目金额：</p>
              <div class="c-financial-rt-input inputbox">
                <input type="text" name="" v-model="amountlower">
                <span>至</span>
                <input type="text" name="" v-model="amountupper">
                <span>元</span>
                <label>
                  <input type="checkbox" name="" v-model="nonamount">
                  面议
                </label>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>截止时间：</p>
              <div class="c-profile-rt-txt">
                <el-date-picker v-model="expiredtime" type="date" placeholder="选择日期" size="small" :clearable="false"
                  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>联系人：</p>
              <div class="c-financial-rt-input">
                <input type="text" placeholder="联系人" v-model="contacts">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>机构名称：</p>
              <div class="c-financial-rt-input">
                <input type="text" maxlength="18" placeholder="机构名称" v-model="orgname">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>联系电话：</p>
              <div class="c-financial-rt-input">
                <input type="text" placeholder="联系电话" v-model="mobile" maxlength="11">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>图片：</p>
              <div class="c-financial-rt-input">
                <div class="filebox">
                  <img v-for="(img, index) in imgPreviews" :key="index" :src="img">
                  <div class="file-btn">
                    <img src="../assets/main/failbg.png">
                    <Upload v-if="imgPreviews.length < 1" class="file-btn__upload" accept="image/png, image/jpeg"
                      v-on:resetImageName="resetImageName" btnText="上传配图">
                      <span class="file-btn__upload-btn"></span>
                    </Upload>
                  </div>
                  <p class="tips">最佳尺寸230*230，每张不超过2M，图片类型必须是jpg,png的一种。</p>
                </div>
              </div>
            </li>
          </template>
          <template v-if="selectedTypeKey === 1">
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>专业领域：</p>
              <div class="c-financial-rt-input">
                <select class="select-box" v-model="selzy">
                  <option v-for="key,index in zyly" :value="index">{{key}}</option>
                </select>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>细分领域：</p>
              <div class="c-financial-rt-input">
                <select class="select-box" v-model="selxf">
                  <option v-for="key,index in xfly[selzy]" :value="index">{{key}}</option>
                </select>
              </div>
            </li>
            <!-- <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>专业领域：</p>
              <div class="c-profile-rt-input">
                <NewConstructor :selectedOptions="industryCategory" v-on:dataChange="handleNewConstructorChange" />
              </div>
            </li> -->
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>所在地区：</p>
              <div style="display: inline-block;float:left;margin-right:20px;">
                <CityCascader placeholderstr="选择省市" v-on:resetDefaultValue="setAddress" :defaultlevel1name="province"
                  :defaultlevel2name="district"></CityCascader>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目名称：</p>
              <div class="c-financial-rt-input">
                <input type="text" maxlength="18" placeholder="项目名称" v-model="title">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目金额：</p>
              <div class="c-financial-rt-input inputbox">
                <input type="text" name="" v-model="amountlower">
                <span>至</span>
                <input type="text" name="" v-model="amountupper">
                <span>元</span>
                <label>
                  <input type="checkbox" name="" v-model="nonamount">
                  面议
                </label>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>项目描述：</p>
              <div class="c-financial-rt-input">
                <textarea class="textarea" placeholder="请描述你的需求"></textarea>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>截止时间：</p>
              <div class="c-profile-rt-txt">
                <el-date-picker v-model="expiredtime" type="date" placeholder="选择日期" size="small" :clearable="false"
                  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>联系人：</p>
              <div class="c-financial-rt-input">
                <input type="text" placeholder="联系人" v-model="contacts">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>机构名称：</p>
              <div class="c-financial-rt-input">
                <input type="text" maxlength="18" placeholder="机构名称" v-model="orgname">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>联系电话：</p>
              <div class="c-financial-rt-input">
                <input type="text" placeholder="联系电话" v-model="mobile" maxlength="11">
              </div>
            </li>
            <li>
              <p class="c-financial-lf-txt"><span class="needed">*</span>产品图片：</p>
              <div class="c-financial-rt-input">
                <div class="filebox">
                  <div class="filebox">
                    <img v-for="(img, index) in imgPreviews" :key="index" :src="img">
                    <div class="file-btn">
                      <img src="../assets/main/failbg.png">
                      <Upload v-if="imgPreviews.length < 1" class="file-btn__upload" accept="image/png, image/jpeg"
                        v-on:resetImageName="resetImageName" btnText="上传配图">
                        <span class="file-btn__upload-btn"></span>
                      </Upload>
                    </div>
                    <p class="tips">最佳尺寸230*230，每张不超过2M，图片类型必须是jpg,png的一种。</p>
                  </div>
                </div>
              </div>
            </li>
          </template>


          <!-- <li>
            <p class="c-financial-lf-txt"><span class="needed">*</span>服务地址：</p>
            <div class="c-financial-rt-input">
              <input type="text"  placeholder="详细地址" v-model="address">
            </div>
          </li> -->

        </ul>
        <div class="btnbox">
          <button class="cancel-btn" @click="$router.back(-1)">取消</button>
          <button class="submit-btn" @click="publishProject">提交</button>
        </div>
      </div>
    </div>
    <Footer :isLogin="true" />
  </div>

</template>
<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import CityCascader from '@/components/common/MyCascader/city'
  import Upload from '@/components/common/Upload';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import NewConstructor from '../components/personal-center/components/NewConstructor.vue'
  import config from '@/config/index';
  import {
    DatePicker
  } from 'element-ui'
  import {
    addProject,
    modifyProject,
    searchproject,
    getProject,
    projectSingup,
    projectSingups,
    deleteMyProject,
    myprojectsignupelist,
    projectcomment
  } from '@/api/project.js'
  import {
    validScc,
    validateTelphone,
    validMobile
  } from '@/utils/validTools.js'
  export default {
    name: 'ProjectPublish',
    components: {
      Header,
      Footer,
      Upload,
      NewConstructor,
      CityCascader,
      [DatePicker.name]: DatePicker,
    },
    watch: {
      $route(to, from) {
        let type = this.$route.query.type === 'project' ? 0 : 1
        this.changeType(type)
      },
      selxf(n,o) {
        console.log("n,o---",n,"----",o)
        let type = this.xfly[this.selzy][n]
        console.log("type----",type)
        this.changeImg(type)
      }
    },
    mounted() {
      let userInfor = getCacheUserInfo()
      if (userInfor.name) {
        this.contacts = userInfor.name
      }
      if (userInfor.account) {
        this.mobile = userInfor.account
      }
      if (userInfor.organization) {
        this.orgname = userInfor.organization
      }
      if (userInfor.province && userInfor.district) {
        this.province = userInfor.province
        this.district = userInfor.district
      }
      let type = this.$route.query.type === 'project' ? 0 : 1
      this.changeType(type)
      let ty = this.xfly[this.selzy][this.selxf]
      this.changeImg(ty)
    },
    data() {
      return {
        title: '', //标题
        projectdetail: '', //详情
        orgname: '',
        projectdeeplearn: '0', //项目解读
        initiatoruid: '', //发起人uid
        phase: '2', //项目阶段 1.看政策2.查项目3.找资金4.获担保
        industrycategory: '', //行业分类
        amountlower: '', //资金下限
        amountupper: '', //资金上限
        nonamount: 0, //资金面议 1 生效
        expiredtime: '', //项目截止日期
        contacts: '', //联系人
        mobile: '', //电话
        province: '', //省份
        district: '', //地区
        projecttype: '', //分类：0 产品 1 服务
        projectcategory: '咨询规划', //服务分类
        imgs: '', //项目图片
        isshow: '', //是否显示 0 不显示 1 显示
        address: '无',
        imgKeys: [],
        imgPreviews: [],
        industryCategory: '',
        projectImgs: {
          project1yy:[
            '智慧政务应用',
            '智慧城市应用',
            '智慧民生应用',
            '智慧产业应用',
            '传统基础设施赋能',
            '中小企业赋能',
          ],
          project2zn: [
            '数据中心',
            '云边端',
            '大数据平台',
            '人工智能',
            '区块链服务平台',
            '数据交易'
          ],
          project3st: [
            '产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台',
          ],
          project4aq: [
            '基础安全能力', '行业应用安全', '新型安全服务平台',
          ],
          project5wl: [
            '5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网',
          ],
          project6zq: ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
          project7sy: ['云计算', '域名',
            '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'
          ],
          project8jr: ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
        },
        publishTypes: [{
            key: 0,
            type: 'project',
            name: '服务',
            active: true
          },
          {
            key: 1,
            type: 'product',
            name: '产品',
            active: false
          }
        ],
        selectType: 0,
        zyly:['智慧应用','数据智能','生态系统','可信安全','新型网络','智慧专区','数字上云','金融服务'],
        xfly:{
          0:['智慧政务应用','智慧城市应用','智慧民生应用','智慧产业应用','传统基础设施赋能','中小企业赋能'],
          1:['数据中心','云边端','大数据平台','人工智能','区块链服务平台','数据交易'],
          2:['产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台'],
          3:['基础安全能力', '行业应用安全', '新型安全服务平台'],
          4:['5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网'],
          5:['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
          6:['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'],
          7:['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
          },
          selzy:0,
          selxf:0
      }
    },
    computed: {
      selectedTypeKey() {
        let type = this.publishTypes[0]
        type = this.publishTypes.find((t) => {
          // console.log(t)
          return t.active;
        })
        if (!type) {
          this.publishTypes[0].active = true
          type = this.publishTypes[0]
        }
        return type.key
      }
    },
    methods: {
      changeType(typeKey) {
        console.log("typeKey>>>", typeKey)
        this.selectType = typeKey
        this.publishTypes = this.publishTypes.map((t) => {
          t.active = typeKey === t.key;
          return t;
        })
      },
      resetImageName(key) {
        if(this.imgKeys.length>0){
          this.imgKeys.length = []
        }
        if(this.imgPreviews.length>0){
          this.imgPreviews.length = []
        }
        this.imgKeys.push(key);
        this.imgPreviews.push(`${config.HOST_IMG}${key}`);
      },
      handleNewConstructorChange(param) {
        console.log("handleNewConstructorChange", param)
        this.industryCategory = param
        this.changeImg(param)
      },
      changeImg(ty) {
        var type = ty.replace(/(^;)|(;$)/g,'');
        for(var img in this.projectImgs){
          var keys = this.projectImgs[img]
          for(var i=0;i<keys.length;i++){
            if(type===keys[i]){
              this.resetImageName(`project/${img}.png`)
              console.log("this.imgPreviews----",this.imgPreviews)
              return
            }
          }
        }
      },
      setAddress(address) {
        console.log(address);
        this.province = address.provName;
        this.district = address.areaName;
      },
      publishProject() {
        let uid = getCacheUserInfo().uid
        if (!this.title) {
          this.$message.error('产品或服务标题不能为空');
          return null;
        }
        if (!this.projectdetail) {
          this.$message.error('产品或服务详情不能为空');
          return null;
        }
        //如果服务服务分类不能为空
        if (this.projecttype === 1 && !this.industrycategory) {
          this.$message.error('服务分类不能为空');
          return null;
        }
        if (this.nonamount) {
          this.amountlower = 0
          this.amountupper = 0
          console.log(this.amountlower, '-----', this.amountupper)
        }
        if (this.nonamount === 0 && (!this.amountlower || !this.amountupper)) {
          this.$message.error('资金下限及上限不能为空');
          return null;
        }
        if (!this.expiredtime) {
          this.$message.error('项目截止日期不能为空');
          return null;
        }
        // console.log('this.projectcategory', this.projectcategory)
        // if (!this.industryCategory || this.industryCategory === "") {
        //   this.$message.error('新基建领域必须勾选');
        //   return null;
        // }
        if (!this.contacts) {
          this.$message.error('联系人不能为空');
          return null;
        }
        if (!this.mobile) {
          this.$message.error('联系电话不能为空');
          return null;
        }
        if (!validMobile(this.mobile)) {
          this.$message.error('请输入正确的手机号码')
          return null;
        }
        if (!this.province) {
          this.$message.error('省份不能为空');
          return null;
        }
        if (!this.district) {
          this.$message.error('区县不能为空');
          return null;
        }
        if (!this.address) {
          this.$message.error('详细地址不能为空');
          return null;
        }
        if (!this.imgKeys || this.imgKeys.length <= 0) {
          this.$message.error('项目图片不能为空');
          return null;
        }
        let params = {
          title: this.title, //标题
          projectdetail: this.projectdetail, //详情
          projectdeeplearn: this.projectdeeplearn, //项目解读
          initiatoruid: uid, //发起人uid
          phase: this.phase, //项目阶段 1.看政策2.查项目3.找资金4.获担保
          industrycategory: this.xfly[this.selzy][this.selxf],//this.industryCategory, //行业分类
          amountlower: this.amountlower, //资金下限
          amountupper: this.amountupper, //资金上限
          nonamount: this.nonamount ? 1 : 0, //资金面议 1 生效
          expiredtime: this.expiredtime, //项目截止日期
          contacts: this.contacts, //联系人
          mobile: this.mobile, //电话
          province: this.province, //省份
          district: this.district, //地区
          address: this.address,
          projecttype: this.selectType, //分类：0 产品 1 服务
          projectcategory: this.projectcategory, //服务分类 或者 产品分类
          imgs: JSON.stringify(this.imgKeys), //项目图片
          isshow: 1, //是否显示 0 不显示 1 显示
        }

        // console.log(params)
        // return;
        this.$http.post(addProject(), params).then(res => {
          console.log(res);
          if (res.code === 1) {
            // this.$router.push('org');
            this.$router.back(-1)
            this.$message.success("需求发布成功");
          } else {
            this.$message.warning(res.msg);
          }
        });

      },
    }
  }
</script>

<style>
  @import url(./ProjectPublish.css);

  .needed {
    color: red;
  }

  .file-btn {
    position: relative;
  }

  .file-btn__upload {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
  }

  .file-btn__upload-btn {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
  }

  .item-label {
    vertical-align: text-bottom;
  }
</style>
